export const LAWN_SPACE_SFX_PREF_KEY = 'wgis:lawn-space-shooter:sfx-enabled'

type PrefStorage = Pick<Storage, 'getItem' | 'setItem'>

function getStorage(): PrefStorage | null {
  if (typeof window === 'undefined') return null
  try {
    return window.localStorage
  } catch {
    return null
  }
}

let cached: boolean | undefined

export function readSfxEnabled(
  storage: PrefStorage | null = getStorage(),
  key: string = LAWN_SPACE_SFX_PREF_KEY,
): boolean {
  if (cached !== undefined && storage === getStorage()) return cached
  if (!storage) return true

  try {
    const value = storage.getItem(key)
    const enabled = value === null ? true : value === '1'
    if (storage === getStorage()) cached = enabled
    return enabled
  } catch {
    return true
  }
}

export function writeSfxEnabled(
  enabled: boolean,
  storage: PrefStorage | null = getStorage(),
  key: string = LAWN_SPACE_SFX_PREF_KEY,
): boolean {
  if (storage === getStorage()) cached = enabled
  if (!storage) return enabled

  try {
    storage.setItem(key, enabled ? '1' : '0')
  } catch {
    // ignore quota / disabled storage
  }
  return enabled
}

export function resetSfxPreferenceCache() {
  cached = undefined
}
